import React from "react";
import WhatsAppIcon from "../icons/WhatsAppIcon";

export default function WhatsAppFloat() {
  const message = encodeURIComponent(
    "Hello! I'd like to know more about R Maart."
  );
  const href = `https://wa.me/917278919919?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="WhatsApp"
      className="fixed bottom-6 left-6 z-40 group"
    >
      <div className="relative">
        <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping" />
        <div className="relative w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.4)] hover:scale-105 transition-transform">
          <WhatsAppIcon className="w-7 h-7" />
        </div>
      </div>
      <span className="absolute left-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-white border border-[#E5E1D5] text-[#1A1813] text-sm font-latin px-3 py-1.5 rounded-lg shadow-md opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        WhatsApp us
      </span>
    </a>
  );
}
